// extracted by mini-css-extract-plugin
export default {"container":"Classroom_container__iAbgp","newClassroomContainer":"Classroom_newClassroomContainer__IzdYq"};